import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const LowBalance = loadable(() => pMinDelay(import('./LowBalance'), 300), {
  fallback: <Loading />
});

const AsyncLowBalance = props => {
  const pageConfig = {
    headerType: 'none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent?.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <LowBalance { ...props } />
    </ApplicationLayout>
  );
};

AsyncLowBalance.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncLowBalance;
